export enum TopicType {
  Event = 'event',
  MethodRequest = 'command',
  MethodResponse = 'event',
}

const createMessageTopic = (type: string) => (
  domain: string,
  serviceName: string,
  name: string,
  provider: string = 'wh'
) => `${provider}.${domain}.${type}.${serviceName}.${name}`;

export const getEventTopic = createMessageTopic(TopicType.Event);
export const getRequestTopic = createMessageTopic(TopicType.MethodRequest);
export const getResponseTopic = createMessageTopic(TopicType.MethodResponse);
